import { useContext } from "react";
import { generatePath } from "react-router";
import { useQueryClient } from "react-query";
import { simpleRequest } from "core/services/api";
import { emptySchema } from "modules/shared/webservices/schemas/responseSchemas";
import { methodSchema } from "core/schemas/http";
import { ENDPOINTS } from "modules/shared/webservices/constants/endpoints";
import { useMutationWithErrorHandling } from "modules/shared/hooks/useMutationWithErrorHandling";
import useFeedbackStore from "modules/feedback/hooks/useFeedbackStore";
import {
  feedbackSchema,
  actionsSchema,
} from "core/components/ActionFeedback/schemas/actionSchemas";
import { UserIdContext } from "modules/shared/context/UserIdContext";
import { useSelfcare } from "modules/selfcare/hooks/useSelfcare";

export const deleteTestCard = (test_card_id: string, userId?: string) =>
  userId
    ? simpleRequest(
        generatePath(ENDPOINTS.USER_TEST_CARD, { id: userId, test_card_id }),
        emptySchema,
        methodSchema.enum.delete
      )
    : Promise.reject();

export const useDeleteTestCard = () => {
  const { data } = useSelfcare(false);
  const contextUserId = useContext(UserIdContext);
  const userId = contextUserId ?? data?.id.toString();
  const queryClient = useQueryClient();
  const { setFeedback } = useFeedbackStore();
  return useMutationWithErrorHandling(
    (data: string) => deleteTestCard(data, userId),
    {
      onSuccess: () => {
        contextUserId
          ? queryClient.invalidateQueries(["userTestCards", Number(userId)])
          : queryClient.invalidateQueries(["selfcare"]);
        setFeedback(feedbackSchema.enum.success, actionsSchema.enum.deleteCard);
      },
    }
  );
};
